// Seed de taxonomia fixa (motivos, expense_categories) — porte de
// 20260902090700_seed_motivos.sql e dos 6 valores inseridos em
// 20260911150000_v13_financeiro.sql (mantidos no historico do git). Tambem
// os 2 scripts de abordagem que ja tinham sido escritos numa sessao
// anterior (2026-09-04, ainda no Supabase) — recuperados do historico da
// conversa, nunca migrados porque a troca de backend partiu do zero.
//
// POR QUE ISSO VIVE NO APP, NAO NUMA MIGRATION: sem Cloud Functions/Admin
// SDK, nao ha um jeito de rodar "migration" alguma contra o Firestore de
// fora do app — so o cliente autenticado (via firestore.rules) pode
// escrever. Idempotente: cada seed confere o que ja existe antes de
// escrever, entao clicar "Seed" de novo nao duplica nada.
import { addDoc, collection, doc, getDocs, setDoc } from "firebase/firestore";
import { db } from "./firebase";

export async function seedMotivosSeNecessario(): Promise<number> {
  const existentes = await getDocs(collection(db, "motivos"));
  if (!existentes.empty) return 0;

  const linhas: {
    categoria: "recusa" | "nao_fechou";
    codigo: string;
    rotulo: string;
    exige_detalhe: boolean;
    ordem: number;
  }[] = [
    { categoria: "recusa", codigo: "preco_orcamento", rotulo: "Preço / orçamento", exige_detalhe: false, ordem: 1 },
    { categoria: "recusa", codigo: "ja_tem_fornecedor", rotulo: "Já tem fornecedor", exige_detalhe: false, ordem: 2 },
    { categoria: "recusa", codigo: "nao_e_prioridade_agora", rotulo: "Não é prioridade agora", exige_detalhe: false, ordem: 3 },
    { categoria: "recusa", codigo: "fora_do_icp", rotulo: "Fora do ICP", exige_detalhe: false, ordem: 4 },
    { categoria: "recusa", codigo: "sem_retorno", rotulo: "Sem retorno", exige_detalhe: false, ordem: 5 },
    { categoria: "recusa", codigo: "outro", rotulo: "Outro", exige_detalhe: true, ordem: 99 },

    { categoria: "nao_fechou", codigo: "preco_orcamento", rotulo: "Preço / orçamento", exige_detalhe: false, ordem: 1 },
    { categoria: "nao_fechou", codigo: "escolheu_concorrente", rotulo: "Escolheu concorrente", exige_detalhe: false, ordem: 2 },
    { categoria: "nao_fechou", codigo: "adiou_decisao", rotulo: "Adiou a decisão", exige_detalhe: false, ordem: 3 },
    { categoria: "nao_fechou", codigo: "fora_do_icp", rotulo: "Fora do ICP", exige_detalhe: false, ordem: 4 },
    { categoria: "nao_fechou", codigo: "sem_retorno", rotulo: "Sem retorno", exige_detalhe: false, ordem: 5 },
    { categoria: "nao_fechou", codigo: "outro", rotulo: "Outro", exige_detalhe: true, ordem: 99 },
  ];

  await Promise.all(
    linhas.map((l) =>
      setDoc(doc(collection(db, "motivos")), {
        ...l,
        ativo: true,
        criado_em: new Date().toISOString(),
      }),
    ),
  );
  return linhas.length;
}

export async function seedExpenseCategoriesSeNecessario(): Promise<number> {
  const existentes = await getDocs(collection(db, "expense_categories"));
  if (!existentes.empty) return 0;

  const categorias = [
    { codigo: "infraestrutura", rotulo: "Infraestrutura (hosting, banco, domínio)", ordem: 1 },
    { codigo: "ferramentas", rotulo: "Ferramentas e assinaturas", ordem: 2 },
    { codigo: "marketing", rotulo: "Marketing e aquisição", ordem: 3 },
    { codigo: "juridico_contabil", rotulo: "Jurídico e contábil", ordem: 4 },
    { codigo: "impostos", rotulo: "Impostos e taxas", ordem: 5 },
    { codigo: "outros", rotulo: "Outros", ordem: 6 },
  ];

  await Promise.all(
    categorias.map((c) =>
      // id do documento = codigo, mesma decisao da migration original.
      setDoc(doc(db, "expense_categories", c.codigo), {
        ...c,
        ativo: true,
        criado_em: new Date().toISOString(),
      }),
    ),
  );
  return categorias.length;
}

const SCRIPT_DESCOBERTA = `ABERTURA (identificação obrigatória - LGPD)
Oi, [NOME DO CONTATO]? Aqui é o [SEU NOME], da Café Labs - a gente é uma startup de desenvolvimento de software, criamos sistemas sob medida pra pequenas e médias empresas. Encontrei o contato de vocês [no site da empresa / no Google], e queria bater um papo rápido, uns 2 minutinhos, pode ser?

Se disser que não pode agora: "Sem problema! Posso ligar em outro dia, ou prefere que eu tire o contato de vocês da nossa lista?" - registre a resposta no sistema.

DESCOBERTA (pergunta-chave)
Legal. Deixa eu te perguntar uma coisa: hoje vocês já usam algum sistema pra [gestão do negócio / agendamento / controle de vendas]?

-- SE NÃO TEM SISTEMA --
Entendi. Muita gente ainda controla isso em caderno, planilha ou WhatsApp mesmo - funciona, mas trava o crescimento em algum momento. A gente desenvolve sistemas sob medida, pensados exatamente pro jeito que o seu negócio funciona, não um modelo genérico. Faz sentido eu te mostrar um pouco melhor numa reunião rápida?

-- SE JÁ TEM SISTEMA --
Que bom que já usam! Só uma curiosidade: esse sistema é próprio de vocês, feito sob encomenda, ou é de terceiros - tipo uma assinatura mensal de algum aplicativo?

   -- SE FOR DE TERCEIROS (paga mensalidade) --
   Entendi. E hoje, quanto mais ou menos vocês pagam de mensalidade nesse sistema? (deixa ele responder, é dado valioso pra reunião)
   Olha, o que a gente costuma mostrar pras empresas nessa situação é que, em vez de pagar mensalidade pra sempre por um sistema genérico, dá pra ter um sistema seu, feito do jeito que vocês precisam, sem ficar pagando taxa todo mês pro resto da vida. Faz sentido eu te mostrar como isso funcionaria pro caso de vocês, numa reunião rápida?

   -- SE JÁ FOR SISTEMA PRÓPRIO/SOB MEDIDA --
   Ah, que legal, então vocês já têm algo pensado especificamente pra vocês. Só pra entender: está atendendo bem, ou tem algo que vocês sentem falta ou gostariam de melhorar? (se mencionar dor, puxa pra reunião; se estiver satisfeito, agradece e encerra educadamente - não insiste)

FECHAMENTO (marcar reunião)
Perfeito. Queria te mostrar melhor como funcionaria, sem compromisso nenhum - consigo [DIA/HORÁRIO] ou [OUTRA OPÇÃO], qual fica melhor pra você? (ao confirmar, marcar como "Reunião agendada" no sistema com data/hora)

OBJEÇÕES COMUNS
- "Manda por e-mail/WhatsApp" -> Claro, te mando agora! Só pra eu já ir preparando algo direcionado: qual é o principal desafio de vocês hoje?
- "Não tenho interesse" -> Sem problema, obrigado pelo seu tempo! Só confirma: posso te contatar de novo mais pra frente, ou prefere que eu tire vocês da lista? (registrar como "não contatar" se pedir)
- "Já tenho fornecedor e estou satisfeito" -> Agradecer e encerrar; marcar como "Recusou - já tem fornecedor".`;

const SCRIPT_DIRETO = `- É da [NOME DA EMPRESA]?
- Meu nome é [SEU NOME], sou da Café Labs. Vou ser direto com você: tenho uma proposta pra fazer pra [NOME DO NEGÓCIO], quer desligar agora ou topa me dar 30 segundos e aí você decide?

[Resposta positiva] A gente desenvolve sistemas sob medida pra empresas como a sua. Hoje vocês já usam algum sistema - de gestão, agenda, vendas, o que for?

   [Não tem sistema] Muita gente ainda resolve isso no caderno ou na planilha - funciona até travar o crescimento. A gente monta um sistema do jeito que seu negócio realmente funciona, não um modelo genérico. Faz sentido eu te mostrar como ficaria?

   [Tem sistema de terceiro/mensalidade] Se vocês já pagam mensalidade nisso, olha só: em vez de pagar essa taxa pro resto da vida, dá pra ter um sistema seu, feito sob medida, e vocês param de pagar mensalidade nele. Faz sentido eu te mostrar como isso ficaria no seu caso?

   [Tem sistema próprio] Que bom, então já é de vocês. Só uma pergunta: está resolvendo tudo, ou tem algo que sentem falta?

[Resposta positiva] Maravilha, qual o melhor horário pra gente fazer uma chamada rápida no Google Meet e eu te mostro como funcionaria?

[Agendou] pegar e-mail e nome pra mandar o convite de agenda.

[Resposta negativa] Sem problema, posso te ligar em outro momento, ou prefere que eu tire vocês da nossa lista?`;

/** Os 2 scripts escritos numa sessão anterior (2026-09-04), recuperados do
 * histórico da conversa — a migração de backend não carregou dado nenhum
 * porque partiu do zero (não havia projeto Supabase real em produção). */
export async function seedScriptsSeNecessario(): Promise<number> {
  const existentes = await getDocs(collection(db, "scripts_abordagem"));
  if (!existentes.empty) return 0;

  const agora = new Date().toISOString();
  const scripts = [
    {
      ramo: null,
      titulo: "Primeira abordagem - descoberta de sistema atual",
      conteudo: SCRIPT_DESCOBERTA,
      canal: "ligacao" as const,
    },
    {
      ramo: null,
      titulo: "Primeira abordagem - estilo direto (30 segundos)",
      conteudo: SCRIPT_DIRETO,
      canal: "ligacao" as const,
    },
  ];

  await Promise.all(
    scripts.map((s) =>
      addDoc(collection(db, "scripts_abordagem"), {
        ...s,
        ramo_normalizado: null,
        ativo: true,
        criado_por: null,
        criado_em: agora,
        atualizado_em: agora,
      }),
    ),
  );
  return scripts.length;
}
